import { Navigate } from 'react-router-dom'
import { getDefaultRedirectPath } from '@/utils/helper'

/**
 * DefaultRedirect Component
 *
 * This component evaluates the default redirect path at render time,
 * preventing infinite loop issues with history.replaceState.
 *
 */
export default function DefaultRedirect() {
  const redirectPath = getDefaultRedirectPath()
  return <Navigate to={redirectPath} replace />
}
